import { AppConstants } from '../app.constants';
import { ViewMode } from '../core/enums/view-mode.enum';

export function recalculateElementMaxWidthAndHeight(viewMode: ViewMode, elementId: string, isToCheckResize: boolean = false): void {
    // calculated width and height for full-screen on our own
    const monitor: HTMLElement = document.getElementById(elementId);
    if (monitor) {
        if (viewMode === ViewMode.FullScreen) {
            if (monitor) {
                const selectedFullScreen: Element = document.getElementsByClassName(AppConstants.SELECTED_FULL_SCREEN_CLASS_NAME)[0];
                if (selectedFullScreen) {
                    const selectedFullScreenHeight: number = selectedFullScreen.clientHeight;
                    const selectedFullScreenWidth: number = selectedFullScreen.clientWidth;
                    const elementWidth: number = isToCheckResize ?
                        selectedFullScreenWidth : monitor.clientWidth + AppConstants.DEFAULT_MONITOR_INTERNAL_PADDING_WIDTH;
                    const elementHeight: number = elementWidth * AppConstants.MONITOR_HEIGHT_TO_WIDTH_PROPORTION;

                    monitor.style.height = `${elementHeight}px`;
                    if (elementHeight > selectedFullScreenHeight) {
                        const newWidth = ((monitor.clientHeight + AppConstants.DEFAULT_MONITOR_INTERNAL_PADDING_WIDTH) /
                            AppConstants.MONITOR_HEIGHT_TO_WIDTH_PROPORTION);
                        monitor.style.width = `${newWidth}px`;
                    }
                }
            }
        } else if (viewMode === ViewMode.Monitors) {
            const elementWidth: number = (monitor.clientWidth || monitor.firstElementChild.clientWidth)
                + AppConstants.DEFAULT_MONITOR_INTERNAL_PADDING_WIDTH;
            const monitorHeight: number = elementWidth * AppConstants.MONITOR_HEIGHT_TO_WIDTH_PROPORTION;
            monitor.style.height = `${monitorHeight}px`;
        } else if (monitor) {
            monitor.style.height = `${AppConstants.DEFAULT_MONITOR_HEIGHT}px`;
        }
    }
}